const simulado = {
	ultimaPart: 0 
}

export default simulado


// WEBPACK FOOTER //
// ./src/domain/store.js